export default {
    clickHereButton: 'contact support',
    tryAgainButton: 'Try again?',
    submitButton: 'Submit',
    submitFeedbackButton: 'Submit Feedback',
    supportError:
        'Error sending message. Please try again or email us directly at members@myfreecamsmail.com',
    supportMessage: 'If you have a support related issue, please ',
    supportSuccess:
        'Your message has been sent to MyFreeCams Support. We will respond as soon as possible.',
    successMessage: 'Your feedback has been submitted',
    errorMessage:
        'We encountered an error. Please try again or email us directly at appfeedback@myfreecams.com',
    authErrorMessage: 'Sorry, only registered members may access this feature.',
    textFieldPlaceholder: 'Enter your feedback (10 character minimum)',
    supportTextfieldPlaceholder: 'Enter your message (10 character minimum)',
}
